import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import {  isEmpty, map, size } from "lodash";
import BreadcrumbClient from "../../components/Common/BreadcrumbClient"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import ClientLink from "./client-link";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import DeleteModal from "../../components/Common/DeleteModal";
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { addClientDocument,getClientDocument, getClientDetail, deleteClientDocument, updateClientDocument} from "../../store/clients/actions"
import Moment from 'react-moment';
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { BlobServiceClient } from '@azure/storage-blob';
import Swal from 'sweetalert2'
import { azureConfig } from "helpers/azureConfig";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import UpdateButton from "components/buttons/updateBtn";
import RsLink from "components/buttons/rsLink";
import SaveButton from "components/buttons/save";
import ClientActivityBreadcrumbs from "components/Common/ClientActivityBreadcrumb";
import ClientActivityMenu from "./menu/client-activity-menu";
import ActionDelete from "components/buttons/actionDelete";
import { UPLOADTEXT } from "constants/layout";
import SafeField from "helpers/SafeField";
import { hasPermission } from "helpers/checkPermission";
class ClientDocument extends Component {
  constructor(props) {
    super(props)
    this.state = {
    
      document:''
    }
  
    this.handleDocumentSubmit = this.handleDocumentSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleSend = this.toggleSend.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
  }

   async handleFileChange(event, setFieldValue) {
      const file = event.currentTarget.files[0];
      if (file) {
        const maxSize = 5 * 1024 * 1024;
        const allowedTypes = ['application/pdf', 'application/msword', 'image/jpeg', 'image/png'];
        const allowedExtensions = ['.pdf', '.doc', '.jpg', '.jpeg', '.png', '.webp'];
        const fileExtension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
        if (!allowedTypes.includes(file.type) || !allowedExtensions.includes(fileExtension)) {
          Swal.fire({
            title: 'File type or extension not allowed',
            text: 'Please upload a PDF, DOC, JPG, or PNG file.',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
          //alert('Invalid file type. Please upload a PDF, DOC, JPG, or PNG file.');
          return;
        }
        if (file.size > maxSize) {
          Swal.fire({
            title: 'Size not allowed',
            text: 'Please Upload Maximum 5MB File',
            icon: 'warning',
            confirmButtonText: 'OK',
          });
         
        }
        this.setState({ btnloading: true });
        const sasToken = azureConfig.sasToken;
        const containerName = azureConfig.containerName;
        const storageAccountName = azureConfig.storageAccountName;
        const fileName = `${Date.now()}_${file.name}`;
        const blobServiceClient = new BlobServiceClient(
          `https://${storageAccountName}.blob.core.windows.net?${sasToken}`
        );
        const containerClient = blobServiceClient.getContainerClient(containerName);
        const blobClient = containerClient.getBlockBlobClient(fileName);
  
        try {
          await blobClient.uploadBrowserData(file, {
            blobHTTPHeaders: { blobContentType: file.type }
          });
  
       
          if (setFieldValue) {
            const fileUrl = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${fileName}`;
            setFieldValue(`documentLink`, fileUrl);
            setFieldValue(`documentContent`, fileUrl);
            this.setState({ fileUploaded: true });
          }
        } catch (error) {
          console.error('Error uploading file:', error);
  
        }
      }
    }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (document) => {
    this.setState({ document: document });
    this.setState({ deleteModal: true });
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }

  handleDeleteDocument = () => {
    const { onDeleteDocument } = this.props;
    const { document } = this.state;
    
    if (document.id !== undefined) {
      onDeleteDocument(document);
      this.setState({ deleteModal: false });
    }
  };
  handleDocumentSubmit(values, actions) {
    //
    this.props.addClientDocument(values, this.props.history);
    actions.resetForm();
    this.setState({
      documentTitle: "",
      isUrgent: "",
      documentLink: "",
    });

     if (this.fileInput) {
    this.fileInput.value = "";
  }
  actions.setSubmitting(false);

  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail, onGetClientDocuments } = this.props;
    onGetClientDetail(params.clientId);
    onGetClientDocuments(params.id);
}
componentDidUpdate(prevProps, prevState, snapshot) {
  const { documents } = this.props;
  if (!isEmpty(documents) && size(prevProps.documents) !== size(documents)) {
    this.setState({ documents: {}, isEdit: false });
  }
}
toggleSend(){
  this.setState({ isSend: !this.state.isSend });
  //this.toggle();
}
toggleRightCanvas() {
  this.setState({ document: "", isEdit: false, isRight: !this.state.isRight });
  this.toggle();
}
toggleRightCanvas = arg => {
  const document = arg;

  this.setState({
    document: {
  
      id:document.id,
      documentId: document.documentId,
      documentFromId:document.documentFromId,
      documentToId: document.documentToId,
      documentTitle: document.documentTitle,
      documentFrom: document.documentFrom,
      documentTo: document.documentTo,
      documentLink: document.documentLink,
      documentContent: document.documentContent,
      documentTypeId: document.documentTypeId,
      documentStorageType: document.documentStorageType,
      agentId: document.agentId,
      isActive: document.isActive,
      isUrgent: document.isUrgent,
      createdDate:document.createdDate,
      documentUrl:document.documentUrl
    },
    isEdit: true,
  });
  this.toggle();
};
  render() {
    const { documents, clietDetail, onUpdateClientDocument, loading, userdetail, isResponsive } = this.props;
    const { filename } = this.state;
    const document = this.state.document;
    const { isEdit, deleteModal } = this.state;
    
    return (
      <React.Fragment>
         
         {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
         
          <ToastContainer autoClose={2000} />
          <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteDocument}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
         <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
              <Row className="project-header">
                <Col sm="7">
             <ClientActivityBreadcrumbs
              title={this.props.t("Clients")}
              breadcrumbItem={this.props.t( " Documents")}
            />
            </Col>
            <Col sm="4" className="">
                <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                </Col>
            </Row>
            <ClientActivityMenu userdetail={userdetail} isResponsive={isResponsive} />
            <Row>
              {/* <Col xl="3">
              <ClientLink id={this.props.match.params.id} clientId={this.props.match.params.clientId} />
              </Col> */}
              
              <Col xl="12">
             
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    documentTitle: (this.state && this.state.documentTitle) || "",
                    documentFromId: localStorage.getItem('userId'),
                    documentToId: this.props.match.params.id,
                    documentFrom: "realtor",
                    documentTo: "client",
                    agentId: localStorage.getItem('userId'),
                    //documentContent: this.state.selectedImage,
                    documentStorageType:0,
                    documentLink:'',
                    isUrgent: (this.state && this.state.isUrgent) || "",
                    isActive: true,
              

                  }}
                 validationSchema={Yup.object().shape({
                  documentTitle: Yup.string()
                    .max(50, "Title must not exceed 50")
                    .required("This is Required"),

                  documentLink: Yup.string().when("documentStorageType", {
                    is: 1,
                    then: Yup.string().url("Must be a valid URL").required("This is Required")
                  }),

                
                })}

                  onSubmit={(values, actions) => this.handleDocumentSubmit(values, actions)}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
              <Card className="border-full"> 
                    <CardBody>
                    <div className="mt-0 card-title pheading">Add Documents</div>
              
                   <Row>
                   <Col sm="12">
                      <div className="btn-group" role="group">
                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="documentStorageType"
                          id="documentStorageType1"
                          autoComplete="off"
                          value={0}
                          onChange={() => setFieldValue("documentStorageType", 0)}
                        />
                        <label
                          className="btn btn-outline-secondary"
                          htmlFor="documentStorageType1"
                        >
                          Upload File
                        </label>

                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="documentStorageType"
                          id="documentStorageType2"
                          autoComplete="off"
                          value={1}
                          onChange={() => setFieldValue("documentStorageType", 1)}
                        />
                        <label
                          className="btn btn-outline-secondary"
                          htmlFor="documentStorageType2"
                        >
                          Add Link
                        </label>
                      </div>
                    </Col>
                    <Col sm="4">
                        <FormGroup className="mb-3">
                            <Label htmlFor="documentTitle">
                              {this.props.t("Title*")}
                            </Label>
                            <SafeField
                              name="documentTitle"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.documentTitle && touched.documentTitle
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="documentTitle"
                            />
                             <ErrorMessage
                              name="documentTitle"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        {values.documentStorageType === 0 && (
                          <Col sm="4">
                            <div className="form-group mb-3">
                              <Label htmlFor="file">File upload*</Label>
                               <input
                                    type="file"
                                    className="form-control"
                                     ref={ref => (this.fileInput = ref)}
                                    onChange={event => this.handleFileChange(event, setFieldValue)}
                                  />
                            {errors.file && touched.file && (
                                  <div className="invalid-feedback d-block">{errors.file}</div>
                            )}
                            <small className="text-muted font-size-12">
                              {UPLOADTEXT.DFOR}
                            </small>
                            </div>

                          </Col>
                        )}
                       {values.documentStorageType === 1 && (
                        <Col sm="3">
                          <FormGroup className="mb-3">
                            <Label htmlFor="documentLink">{this.props.t("Link *")}</Label>
                            <SafeField
                              name="documentLink"
                              onChange={handleChange}
                              type="text"
                              className={
                                "form-control" +
                                (errors.documentLink && touched.documentLink
                                  ? " is-invalid"
                                  : "")
                              }
                              id="documentLink"
                            />
                             <ErrorMessage
                              name="documentLink"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      )}
                        <Col sm="1">
                        <FormGroup className="mb-3">
                            <Label htmlFor="isUrgent">
                              {this.props.t("Is Urgent")}
                            </Label>
                            <SafeField as="select" name="isUrgent" className="form-control" onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="1">Yes</option>
                                <option value="2">No</option>
                            </SafeField>
                          </FormGroup>
                        </Col>
                       

                  
                        <Col sm="12">
                        <div className="form-check">
                          <Input
                            type="checkbox"
                            className="form-check-Input"
                            id="formrow-customCheck"
                            style={{marginTop:5}}
                          />
                          <Label
                            className="form-check-Label"
                            htmlFor="formrow-customCheck"
                          >
                            Send text notification 
                          </Label>
                        </div>
                        </Col>
                        <Col sm="2">
                        <div className="clearfix">
                           {hasPermission("RealtorClientDocuments", "Add") && ( <SaveButton iconClass=" bx bx-mail-send">Send Document</SaveButton> )}
                         </div>
                        </Col>
                    </Row>

                
             
             </CardBody>
                </Card>
                
            </Form>
                  )}
			        </Formik>
			 <Row>
				<Col sm="12">
         {hasPermission("RealtorClientDocuments", "View") && (
					 <Card className="border-full mt-4"> 
                    <CardBody>
                    <h5 className="card-title w-100">History

                       <span className="ms-3">
                       <i className=' bx bxs-cloud-upload btn-u' style={{verticalAlign:'middle', position:'relative', top:'-2px'}}></i>
                        <span>{this.props.t(" File sent")}</span>
                      </span>

                      <span className="ms-3">
                     <i className='bx bxs-cloud-download btn-d' style={{verticalAlign:'middle', position:'relative', top:'-2px'}}></i>
                        <span>{this.props.t(" File received")}</span>
                      </span>
                    </h5>
					<div className="table-responsive">
          <table className="table table-striped">
              <thead className="">
							  <tr>
                <th>#</th>
								<th>Date</th>
                {!isResponsive &&(
                  	<th>Type</th>
                )}
							
								<th>Title</th>
                  {!isResponsive &&(
                  	<th>Urgent</th>
                )}
								
                <th>Link</th>
                <th>Action</th>
							  </tr>
							</thead>
							<tbody>
              {map(documents, (document, dockey) => (
               <tr key={"_doc_" + dockey}>
                 <td>{dockey + 1}</td>
                <td><Moment format="D MMM YY">{document.createdDate}</Moment></td>
                {!isResponsive &&(
               <td>{document.documentStorageType > 0 ? 'Link' : 'Upload' }</td>
                )}
                <td>{document.documentTitle}</td>
                  {!isResponsive &&(
                <td>{document.isUrgent == true
                    ? "Yes"
                    : "No"
                }</td>
              )}
                
                <td>{document.documentFrom == 'realtor' ? <a target="_blank" rel="noreferrer" className="btn-u" href={document.documentLink}><i className=' bx bxs-cloud-upload'></i></a> : <a target="_blank" className="btn-d" rel="noreferrer" href={document.documentLink}><i className='bx bxs-cloud-download'></i></a> }</td>
                <td>
                    <ActionDelete onClick={() => this.onClickDelete(document)} />
                {/* <UncontrolledDropdown direction="up">
                                      <DropdownToggle className="btn btn-action" type="button" id="defaultDropdown">
                                        Action <i className="mdi mdi-chevron-down"></i>
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem onClick={() => this.toggleRightCanvas(document)} href="#">Edit</DropdownItem>
                                        <DropdownItem onClick={() => this.onClickDelete(document)}  href="#">Delete</DropdownItem>
                                       
                                        
                                      </DropdownMenu>
                                    </UncontrolledDropdown> */}
                
                </td>
               </tr>
              ))}
							</tbody>
						  </table>
						</div>
					</CardBody>
					</Card>
          )}
				</Col>
			</Row>
            </Col>
            
            </Row>
            </Col>
            </Row>
            <Offcanvas
                      isOpen={this.state.isRight}
                      direction="end"
                      toggle={this.toggleRightCanvas}
                    >
                      <OffcanvasHeader toggle={this.toggleRightCanvas}>
                        Update 
                      </OffcanvasHeader>
                      <OffcanvasBody>
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id:document.id,
                    documentId: document.documentId,
                    documentFromId:document.documentFromId,
                    documentToId: document.documentToId,
                    documentTitle: document.documentTitle,
                    documentFrom: document.documentFrom,
                    documentTo: document.documentTo,
                    documentLink: document.documentLink,
                    documentContent: document.documentContent,
            
                    documentLink: document.documentLink,
                
                    documentTypeId: document.documentTypeId,
                    documentStorageType: document.documentStorageType,
                    agentId: document.agentId,
                    isActive: document.isActive,
                    isUrgent: (document.isUrgent==true) ? true : false,
                    createdDate:document.createdDate,
                    documentUrl:document.documentUrl

                  }}
                  validationSchema={Yup.object().shape({
                    documentTitle: Yup.string().max(50, "Title must not exceed 50").required("This is Required")
                  })}

                  onSubmit={values => {
                    //
                    if (isEdit) {
                      const updateDocument = {
                        id:values.id,
                        documentId: values.documentId,
                        documentFromId:values.documentFromId,
                        documentToId: values.documentToId,
                        documentTitle: values.documentTitle,
                        documentFrom: values.documentFrom,
                        documentTo: values.documentTo,
                        documentLink: values.documentLink,
                        documentContent: values.documentContent,
                        documentTypeId: values.documentTypeId,
                        documentStorageType: values.documentStorageType,
                        agentId: values.agentId,
                        isActive: values.isActive,
                        isUrgent: (values.isUrgent == 'true') ? true : false,
                        createdDate:values.createdDate,
                        documentUrl:values.documentUrl
                      };
                      onUpdateClientDocument(updateDocument);
                    } else {
                      
                    }

                    //this.setState({ selectedOrder: null });
                    this.toggle();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             
              
                   <Row>
                       <Col sm="12">
                      <div className="btn-group" role="group">
                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="documentStorageType"
                          id="documentStorageType1"
                          autoComplete="off"
                          value={0}
                          onChange={() => setFieldValue("documentStorageType", 0)}
                        />
                        <label
                          className="btn btn-outline-secondary"
                          htmlFor="documentStorageType_3"
                        >
                          Upload File
                        </label>

                        <SafeField
                          type="radio"
                          className="btn-check"
                          name="documentStorageType"
                          id="documentStorageType2"
                          autoComplete="off"
                          value={1}
                          onChange={() => setFieldValue("documentStorageType", 1)}
                        />
                        <label
                          className="btn btn-outline-secondary"
                          htmlFor="documentStorageType_4"
                        >
                          Add Link
                        </label>
                      </div>
                    </Col>
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="documentTitle">
                              {this.props.t("Title")}
                            </Label>
                            <SafeField
                              name="documentTitle"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.documentTitle && touched.documentTitle
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="documentTitle"
                            />
                             <ErrorMessage
                              name="documentTitle"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="isUrgent">
                              {this.props.t("Is Urgent")}
                            </Label>
                            <SafeField as="select" name="isUrgent" className="form-control" onChange={handleChange}>
                                <option value="">Select</option>
                                <option value={true}>Yes</option>
                                <option value={false}>No</option>
                            </SafeField>
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                        <div className="form-group mb-3">
                          <Label htmlFor="file">File upload</Label>
                           <input
                                    type="file"
                                    className="form-control"
                                    onChange={event => this.handleFileChange(event, setFieldValue)}
                                  />
                          
                        </div>
                       
                        </Col>

                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="documentLink">
                              {this.props.t("Link")}
                            </Label>
                            <SafeField
                              name="documentLink"
                              onChange={handleChange}                             
                              type="text"
                              className={
                                "form-control" +
                                (errors.documentLink && touched.documentLink
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="documentLink"
                            />
                          </FormGroup>
                        </Col> 
                        <Col sm="12">
                        <div className="form-check">
                          <Input
                            type="checkbox"
                            className="form-check-Input"
                            id="formrow-customCheck"
                            style={{marginTop:5}}
                          />
                          <Label
                            className="form-check-Label"
                            htmlFor="formrow-customCheck"
                          >
                            Send text notification 
                          </Label>
                        </div>
                        </Col>
                        <Col sm="12">
                        <div className="clearfix">
                        <UpdateButton>{this.props.t("Update")}</UpdateButton>{ " " } <RsLink onClick={closed}>Close</RsLink>
                          <button type="submit" className="btn btn-primary w-md mt-27">Update </button></div>
                        </Col>
                    </Row>

                
            </Form>
                  )}
			 </Formik>

                      </OffcanvasBody>
                    </Offcanvas>


                    <Offcanvas
                      isOpen={this.state.isSend}
                      direction="end"
                      toggle={this.toggleSend}
                    >
                      <OffcanvasHeader toggle={this.toggleSend}>
                        Send Document 
                      </OffcanvasHeader>
                      <OffcanvasBody>
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                   

                  }}
                  validationSchema={Yup.object().shape({
                    documentTitle: Yup.string().max(50, "Title must not exceed 50").required("This is Required")
                  })}

                  onSubmit=""
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             
              
                   <Row>
                        <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="documentTitle">
                              {this.props.t("Subject")}
                            </Label>
                            <SafeField
                              name="emailSubject"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.emailSubject && touched.emailSubject
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="emailSubject"
                            />
                             <ErrorMessage
                              name="emailSubject"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                        <FormGroup>
                              {/* <h6 style={{ marginTop: 30 }}>

                                <strong>{this.props.t("Content")}</strong>
                              </h6> */}
                              <Label htmlFor="projectAdditionalFeatureDescription">Email Content</Label>
                              <CKEditor
                                editor={ClassicEditor}
                                onChange={(event, editor) => {
                                  const data = editor.getData();
                                  setFieldValue('emailContent', data);
                                }}

                              />
                            </FormGroup>
                        </Col>
                        <Col sm="12">
                        
                        <UpdateButton iconClass="bx bx-send">{this.props.t("Send")}</UpdateButton>{ " " }
                        
                        </Col>
                    </Row>

                
            </Form>
                  )}
			 </Formik>

                      </OffcanvasBody>
                    </Offcanvas>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientDocument.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  match: PropTypes.object,
  addClientDocument:PropTypes.func,
  onGetClientDocuments:PropTypes.func,
  documents:PropTypes.array,
  onGetClientDetail: PropTypes.func,
  clietDetail:PropTypes.object,
  onDeleteDocument:PropTypes.func,
  onUpdateClientDocument:PropTypes.func,
  loading: PropTypes.object,
  userdetail:PropTypes.object,
  isResponsive:PropTypes.object

}
const mapStateToProps = ({ Clients }) => (
  {
    clietDetail: Clients.clietDetail,
      documents: Clients.documents,
      loading: Clients.loading

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  addClientDocument: (data) => dispatch(addClientDocument(data)),
  onGetClientDocuments:(clientId) => dispatch(getClientDocument(clientId)),
  onDeleteDocument:(id) => dispatch(deleteClientDocument(id)),
  onUpdateClientDocument:(data) => dispatch(updateClientDocument(data))
  
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ClientDocument))
